module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Dashboard2_16"],"path":[{"$":{"d":"M0,2V14H16V2ZM2,7h8v5H2Zm12,5H11V7h3ZM11,6H2V4H14V6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Dashboard2_16.svg
// module id = fxUm
// module chunks = 1